import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'bootstrap-icons/font/bootstrap-icons.css';

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from './pages/Auth/LoginPage';
import HomePage from "./pages/Auth/HomePage";
import UsersManagementPage from './pages/Users/UserManagementPage';
import PermissionsManagementPage from './pages/Permissions/PermissionsManagementPage';
import DashboardLayout from './layouts/DashboardLayout';
import RolesManagementPage from './pages/Rule/RolesManagementPage';
import CreateRolePage from './pages/Rule/CreateRulePage';
import EditRolePage from './pages/Rule/EditRolePage';
import ProtectedRoute from './components/ProtectedRoute';
import ChangePasswordPage from './pages/Users/ChangePasswordPage';
import Establishment from './models/Establishment';
import EstablishmentsPage from './pages/Establishment/EstablishmentsPage';
import EstablishmentDetailsPage from './pages/Establishment/EstablishmentDetailsPage';
import ActivitiesManagementPage from './pages/Activity/ActivitiesManagementPage';
import ViolationTypesManagementPage from './pages/ViolationTypes/ViolationTypesManagementPage';
import ViolationTypeFormPage from './pages/ViolationTypes/ViolationTypeFormPage';
import ViolationPage from './pages/Violations/ViolationPage';
import ViolationDetailsPage from './pages/Violations/ViolationDetailsPage';
import CreateInspectionMissionPage from './pages/InspectionMissions/CreateInspectionMissionPage';
import FacilityTypeManagementPage from './pages/FacilityType/FacilityTypeManagementPage';
import PatrolStaffManagementPage from './pages/PatrolStaff/PatrolStaffManagementPage';
import PatrolStaffFormPage from './pages/PatrolStaff/PatrolStaffFormPage';
import PatrolRosterCreatePage from './pages/PatrolRoster/PatrolRosterCreatePage';
import SalesTypeFormPage from './pages/SalesTypes/SalesTypeFormPage';
import SalesTypesManagementPage from './pages/SalesTypes/SalesTypesManagementPage';
import PatrolRosterManagementPage from './pages/PatrolRoster/PatrolRosterManagementPage';
import PriceSurveyProductsPage from './pages/PriceSurveyProducts/PriceSurveyProductsPage';
import PublicDashboard from './pages/PublicUsers/PublicDashboard';
import PublicProtectedRoute from './components/PublicProtectedRoute';
import PublicEstablishmentDetailsPage from './pages/PublicUsers/PublicEstablishmentDetailsPage';
import SimpleLocation from './pages/PublicUsers/SimpleLocation';
import ComplaintsPage from './pages/Complaint/ComplaintsPage';
import ComplaintDetailsPage from './pages/Complaint/ComplaintDetailsPage';
import ComplaintsDashboard from './pages/Complaint/ComplaintsDashboard';
import FilteredEstablishmentsPage from './pages/Establishment/FilteredEstablishmentsPage';
import VisitDetailsPage from './pages/Visits/VisitDetailsPage';
import VisitsPage from './pages/Visits/VisitsPage';
import PriceSurveyReportPage from './pages/PriceSurvyReports/PriceSurveyReportPage';
import DeviceFingerprint from './pages/PublicUsers/DeviceFingerprint';
import PriceAggregationReportPage from './pages/PriceSurvyReports/PriceAggregationReportPage';
import PriceSurveyMatrixReportPage from './pages/PriceSurvyReports/PriceSurveyMatrixReportPage';
import PriceSurveyCategoriesPage from './pages/PriceSurveyCategories/PriceSurveyCategoriesPage';
import GenerateUIDPage from './pages/GenerateUID/GenerateUIDPage';
import NearbyEstablishments from './pages/PublicUsers/NearbyEstablishments';
import UsdExchangeRatesPage from './pages/USDExchangeRate/UsdExchangeRatesPage';
import Home from './layouts/Home';
import LocationsManagementPage from './pages/LocationsManagement/LocationsManagementPage';
import GenerateUIDPage1 from './pages/GenerateUID/GenerateUIDPage1';
import CameraCapture from './pages/PublicUsers/SimpleCamera';
import ActivityReportsPage from './pages/Reports/ActivityReportsPage';
import AllVisitsPage from './pages/Visits/AllVisitsPage';
import ViolationReportsPage from './pages/Violations/AllViolationPage';
import InspectionMissionsPage from './pages/InspectionMissions/InspectionMissionsPage';
// ... الاستيرادات السابقة تبقى كما هي

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NearbyEstablishments />} />

        {/* صفحة الدخول بدون تخطيط */}
        <Route path="/finger" element={<DeviceFingerprint />} />
        <Route path="/location" element={<SimpleLocation />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/consumer-protection/public/:id" element={<PublicDashboard isPublicView={true} />} />

        {/* المسارات العامة */}
        <Route path="/:id" element={<PublicDashboard />} />

        {/* مجموعة المسارات المحمية للمنشآت */}
        <Route element={<PublicProtectedRoute />}>
          <Route path="/establishment-dashboard/:id" element={<PublicEstablishmentDetailsPage isPublicView={true} />} />
        </Route>

        {/* --- التعديل هنا: إضافة بادئة /admin لمجموعة لوحة التحكم --- */}
        <Route
          path="/admin"
          element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}
        >
          {/* هذا المسار سيفتح عند الدخول على /admin */}
          <Route index element={<Home />} />

          {/* المهام المسندة */}
          <Route path="i" element={<InspectionMissionsPage />} />
          <Route path="inspection-mission/create" element={<CreateInspectionMissionPage />} />

          {/* كل المسارات أدناه ستصبح مسبوقة بـ /admin/ */}
          <Route path="actities-reports" element={<ActivityReportsPage />} />
          <Route path="visits-report" element={<AllVisitsPage />} />
          <Route path="violation-report" element={<ViolationReportsPage />} />

          <Route path="change-password" element={<ChangePasswordPage />} />
          <Route path="users-management" element={<UsersManagementPage />} />
          <Route path="users-management/create" element={<Navigate to="/admin/users-management" replace />} />
          <Route path="users-management/edit/:id" element={<Navigate to="/admin/users-management" replace />} />
          <Route path="permissions-management" element={<PermissionsManagementPage />} />
          <Route path="permissions-management/create" element={<Navigate to="/admin/permissions-management" replace />} />
          <Route path="roles-management" element={<RolesManagementPage />} />
          <Route path="roles-management/create" element={<CreateRolePage />} />
          <Route path="roles-management/edit/:id" element={<EditRolePage />} />
          <Route path="users-management/change-password/:userId" element={<Navigate to="/admin/users-management" replace />} />

          <Route path="establishments" element={<EstablishmentsPage />} />
          <Route path="establishments/:id" element={<EstablishmentDetailsPage />} />
          <Route path="establishments-list" element={<FilteredEstablishmentsPage />} />

          <Route path="activities-management" element={<ActivitiesManagementPage />} />
          <Route path="activities-management/create" element={<Navigate to="/admin/activities-management" replace />} />
          <Route path="activities-management/edit/:id" element={<Navigate to="/admin/activities-management" replace />} />

          <Route path="violation-types-management" element={<ViolationTypesManagementPage />} />
          <Route path="violation-types/create" element={<ViolationTypeFormPage />} />
          <Route path="violation-types/edit/:id" element={<ViolationTypeFormPage />} />

          <Route path="violations" element={<ViolationPage />} />
          <Route path="violation-details" element={<ViolationDetailsPage />} />

          <Route path="complaints" element={<ComplaintsPage />} />
          <Route path="complaint-details" element={<ComplaintDetailsPage />} />
          <Route path="all-complaint" element={<ComplaintsDashboard />} />


          <Route path="facilitytypes-management" element={<FacilityTypeManagementPage />} />
          <Route path="facilitytypes-management/create" element={<Navigate to="/admin/facilitytypes-management" replace />} />
          <Route path="facilitytypes-management/edit/:id" element={<Navigate to="/admin/facilitytypes-management" replace />} />

          <Route path="patrolstofs-management" element={<PatrolStaffManagementPage />} />
          <Route path="patrolstaff-management" element={<PatrolStaffManagementPage />} />
          <Route path="patrolstaff-management/create" element={<PatrolStaffFormPage />} />
          <Route path="patrolstaff-management/edit/:id" element={<PatrolStaffFormPage />} />

          <Route path="patrol-rosters" element={<PatrolRosterManagementPage />} />
          <Route path="patrol-rosters/create" element={<PatrolRosterCreatePage />} />

          <Route path="sales-types-management" element={<SalesTypesManagementPage />} />
          <Route path="sales-types-management/create" element={<SalesTypeFormPage />} />
          <Route path="sales-types-management/edit/:id" element={<SalesTypeFormPage />} />

          <Route path="price-survey-products" element={<PriceSurveyProductsPage />} />
          <Route path="visits" element={<VisitsPage />} />
          <Route path="visit-details/:visitUid" element={<VisitDetailsPage />} />
          <Route path="price-survey-report" element={<PriceSurveyReportPage />} />
          <Route path="price-survey-matrix-report" element={<PriceSurveyMatrixReportPage />} />
          <Route path="price-average-survey-report" element={<PriceAggregationReportPage />} />
          <Route path="price-survey-categories" element={<PriceSurveyCategoriesPage />} />
          <Route path="generate-uid" element={<GenerateUIDPage1 />} />
          {/* معدل التداول */}
          <Route path="usd-exchange-rate" element={<UsdExchangeRatesPage />} />
          <Route path="home" element={<Home />} />
          <Route path="location_management" element={<LocationsManagementPage />} />




        </Route>

        {/* إعادة توجيه من الصفحة الرئيسية إلى /admin إذا رغبت بذلك */}
        {/* <Route path="/" element={<Navigate to="/admin" />} /> */}

      </Routes>
    </BrowserRouter>
  );
}


export default App;
